import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog"

interface DiscardUnsavedChangesDialogProps {
  open: boolean
  title: string
  description: string
  confirm_label: string
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

/** Confirmation shown before any flow that reloads the forecast tree over unsaved cell edits. */
export function DiscardUnsavedChangesDialog(props: DiscardUnsavedChangesDialogProps) {
  return (
    <AlertDialog open={props.open} onOpenChange={props.onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{props.title}</AlertDialogTitle>
          <AlertDialogDescription className="space-y-3 text-left text-sm text-gray-700">
            <span className="block">{props.description}</span>
            <span className="block">
              Choose <strong>Keep editing</strong> and use <strong>Save</strong> first if you want to keep them.
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel type="button">Keep editing</AlertDialogCancel>
          <AlertDialogAction type="button" onClick={props.onConfirm}>
            {props.confirm_label}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
